








import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Watcher } from "@/models";
import { sortByFullName } from "../../utils/names";

@Component
export default class WatcherModal extends Vue {
  /**
   * Indicates if the modal is visible. To set it, use the v-model attribute
   */
  @Prop() readonly value!: boolean;
  @Prop() readonly watchers!: Watcher[];

  get sortedWatchers() {
    const watchers = this.watchers || [];
    return watchers.sort(sortByFullName);
  }

  // Used internally to pass this.value (from v-model) to the bootstrap modal
  get show() {
    return this.value;
  }

  // Used internally. Is called when the bootstrap modal updates the state of the modal. This then passes the value to
  // the parent's v-model property.
  set show(val: boolean) {
    this.$emit("input", val);
  }
}
